import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { StackLayout } from "@advosys/component-react";
import { hasValue } from "@advosys/component-react-utils";
import { Spinner, Text } from "@fluentui/react";
import { actions, AuthenticationStateOptions } from "../../authentication-store";
import { k } from "./login-gate-i18n";
const mapStateToProps = (state) => ({
    authenticationState: state.authentication.authentication,
    error: state.authentication.authentication.error
});
const LoginGateBase = (props) => {
    const { tenantId } = useParams();
    const authentication = props.authenticationState.authenticationState;
    const { t } = useTranslation();
    useEffect(() => {
        props.setTenantId(tenantId);
    }, [tenantId]);
    useEffect(() => {
        if (authentication === AuthenticationStateOptions.NotAuthenticated) {
            props.authenticateRequest();
        }
    }, [authentication]);
    if (authentication === AuthenticationStateOptions.Authenticated) {
        if (hasValue(props.authenticationState.tenantId)) {
            return _jsx(_Fragment, { children: props.children });
        }
        return _jsx(Spinner, { label: t(k.loginSpinnerText) });
    }
    if (authentication !== AuthenticationStateOptions.NotAuthenticated && authentication !== AuthenticationStateOptions.InProgress) {
        throw Error("Ugyldig state i LoginGate");
    }
    return (_jsx(StackLayout, { horizontal: true, horizontalAlign: "center", verticalAlign: "center", children: _jsxs(_Fragment, { children: [authentication === AuthenticationStateOptions.NotAuthenticated && (_jsxs(StackLayout, { children: [_jsx(Text, { children: t(k.ikkeLoggetInd) }), props.error && _jsx(Text, { children: props.error })] })), authentication === AuthenticationStateOptions.InProgress && _jsx(Spinner, { label: t(k.loginSpinnerText) })] }) }));
};
export const LoginGate = connect(mapStateToProps, actions)(LoginGateBase);
